import jermainePic from "@/public/images/artists/jermaine.png";
import { Artist } from "@/types/types";

export const jermaine = {
  id: "152",
  name: "Jermaine",
  image: jermainePic,
  description: `Jermaine's voice carries an intense, assured tone, delivering every line with precision and impact, perfectly suited for rap and hip-hop that demands both confidence and edge.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fjermaine-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Hip Hop"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Low",
      },
      specific: {
        low: 48,
        high: 63,
      },
      sweetSpot: 56,
    },
  },
} as const satisfies Artist;
